import { isStringFloat } from '@impuls-coach/util-is';

const inputValidRegex = /[^\d]/g;
const invalidIntRegexp = /[^\d]/g;
const invalidFloatRegexp = /[^\d.]/g;

const _countDecimals = (value: number): number => {
	if (Math.floor(value) !== value) {
		return value.toString().split('.')[1].length || 0;
	}

	return 0;
};

export const sanitizeInteger = (value: string): string => {
	value = value.replace(invalidIntRegexp, '');
	return value;
};

export const sanitizeFloat = (value: string, maxDecimals: number): string => {
	value = value.replace(invalidFloatRegexp, '');

	if (isStringFloat(value)) {
		const n = parseFloat(value);
		if (_countDecimals(n) > maxDecimals) {
			value = n.toFixed(maxDecimals);
		}
	}

	return value;
};

export const sanitizeInput = (value: string): string => {
	let floatTemp: string | number | any = parseFloat(value);

	if (~value.indexOf('.') && value.split('.')[1].length > 2) {
		floatTemp = floatTemp.toFixed(2);
	}

	if (isNaN(floatTemp)) {
		return '';
	}

	return floatTemp.toString().replace(',', '.');
};

export const sanitizeInputInteger = (value: string): string => {
	const floatTemp = parseFloat(value);
	const isNumber = !isNaN(floatTemp);

	if (isNumber) {
		value = Math.floor(floatTemp).toString(10);
	}

	value = value
		.replace('.', '')
		.replace(',', '')
		.replace(inputValidRegex, '');

	return value;
};

export default {
	sanitizeInteger,
	sanitizeFloat,
};
